var _rect, _rect2, _rect3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOneChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_2_8179)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CBE880"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "url(#paint1_linear_2_8179)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1379 20V18.41H14.5229V11.615L12.6779 12.725L11.9279 11.315L15.0779 9.425H16.4429V18.41H18.6779V20H12.1379Z",
    fill: "#7566E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_8179",
    x1: 26.7,
    y1: 0.00000243427,
    x2: 2.02053,
    y2: 7.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7566E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_8179",
    x1: 6.3,
    y1: -1.67856e-8,
    x2: 3.34629,
    y2: 28.6436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneChild);
export default __webpack_public_path__ + "static/media/one-child.5c5971ea9d856a85a1b45ad3271dbe94.svg";
export { ForwardRef as ReactComponent };